<template>
  <CFooter :fixed="false">
    <div class="mfs-auto">
      <span class="mr-1" target="_blank">Copyright © 2020 <a href="https://www.facebook.com/AIEMFU/?eid=ARBZv97lsKbqr60BxSKZWcziOtdEZDJ3LqUBlGOLScd_nsP-IV2STFd-REM_z2tBqXTBCGyWiVIg9s0h&hc_ref=ARTpAKuHbm_EXr5D6Kcn2CKnfpIk2x5cMApV771ZGBXxpel3c5CjQHWU8vlEtJBA2Dc&__xts__[0]=68.ARCPhzhMyMgzANKyYWbo0SVAtna29H-As2ooqO_AqXf40wUIWI9FHdJn-v39oWlyWoGDTOOnuwU9aUmz0WOiFdvO6H2wSj0KsIVLca6WvheQXL8V9xSznpyVF8YcGWzpzKcgWLWdIPPxd8Bz5lF--QH69npYe2qoA7DmoUtYuL0Uzk9A76Mgw2TjTsuiahY-z1rpZnCiW0cS2ESolOiYgJFn-_qbH8rwT4GQAOwsVdgFYQ8cTsMFyFFtkjzdabZ7anJZw6yyCPcc7-90T2vaUNf8zYJ0EyrZBmuWsivSLOf06lfonHbEFE6ee-NCTVBDR1ho_gAXG32XAJ_RH_bFRL0pN_tIuMHYZLhW1E2VlqPSj8IyJER81hVx4TNzrEGGIPHxAAmH7zGnGjl1OWorCOc2l6TgpO7PhjOlpRGI_WLD02Nnxj2S9rTM0hEf5uHLiS-BrIWAmJLwlG2nw5__t_f7hEWE5menSbGmN-aiHivk8U3ulSqcFgq2xFpn8hmm3TfDzm1W4d1ndmmBIgGh4Xl0Vmtx8W830_JLMBN_wU6x1rliJxecxDOEVlIiDiBLqVQ6x5LHHXLb9TbWIFLLsBXSVxc6WJ43">Center of Excellence in AI and Emerging Technology</a>. All Rights Reserved</span>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
